<template>
    <div class="ranking">
        <RankingHeader
            :top-ranking="topRanking"
            @changeFilter="setFilter"
            :filter-props="filters"
        />
        <RankingTabs
            v-if="filters.type"
            :tab="filters.type"
            @changeTab="setTab"
        />
        <RankingTable
            v-if="filters.type"
            :loading="loading"
            :total="total"
            @loadMore="loadMore"
            :data-ranking="rankingData"
        />
        <UserPositionHighlight
            v-if="showCareer && myRank"
           :my-ranking="myRank"
        />
    </div>
</template>

<script>
import RankingHeader from './RankingHeader.vue'
import RankingTabs from './RankingTabs.vue'
import RankingTable from './RankingTable.vue'
import { GET_LIST_RANKING } from "@/core/services/store/kpi/kpi.module";
import moment from "moment-timezone";
import { RankingModel } from "../model/RankingModel";
import UserPositionHighlight from "./UserPositionHighlight.vue";
import {GET_MY_RANKING} from "@/core/services/store/kpi/kpi.module";
import {mapGetters} from "vuex";
import {DEPARTMENT_LEADER, LEADER, LEADER_GROUP, STAFF} from "../../../../common/define";

export default {
    components: { UserPositionHighlight, RankingHeader, RankingTabs, RankingTable },
    data() {
        return {
            filters: {
                quarter: 1,
                year: 2025,
                type: null,
            },
            rankingData: [],
            page: 1,
            myRank: null,
            loading: false,
            total: 0,
        }
    },
    async created() {
        this.getCurrentQuarter()
        await this.getMyRank()
        await this.setTabActive()
        await this.getListRanking()
    },
    computed: {
        topRanking() {
            return this.rankingData?.filter((item, index) => index < 3)
        },
        ...mapGetters(['currentUser']),
        showCareer() {
            const tabs = [DEPARTMENT_LEADER, LEADER, LEADER_GROUP, STAFF];
            const accountType = this.currentUser?.account_type?.id
            return accountType === +tabs[this.filters.type]
        },
    },
    methods: {
        async getListRanking(isLoadMore = false) {
            this.loading = true
            const payload = {
                year :this.filters.year,
                type: this.filters.type ? +this.filters.type : null,
                quarter: this.filters.quarter,
                page: this.page,
                per_page: 10
            }
            await this.$store.dispatch(GET_LIST_RANKING, payload).then(res => {
                if (!res.error) {
                    if (res.data && res.data.length > 0) {
                        const newData = res.data.map((item, index) => {
                            const currentIndex = isLoadMore ? this.rankingData.length + index : index
                            return new RankingModel(item, currentIndex, this.filters.quarter, this.myRank?.userId)
                        })
                        if (isLoadMore) {
                            this.rankingData.push(...newData)
                        } else {
                            this.rankingData = newData
                        }
                    }
                    this.page = res.pagination.current_page
                    this.total = res.pagination.total
                }
            }).catch(e => {
                console.log(e)
            }).finally(() => this.loading = false)
        },
        loadMore() {
            if (this.rankingData.length >= this.total) {
                return
            }
            this.page = this.page + 1
            this.getListRanking(true)
        },
        setTabActive() {
            return new Promise((resolve) => {
                switch (this.currentUser?.account_type?.id) {
                    case STAFF:
                        this.filters.type = '3';
                        break;
                    case DEPARTMENT_LEADER:
                        this.filters.type = '0';
                        break;
                    case LEADER_GROUP:
                        this.filters.type = '2';
                        break;
                    case LEADER:
                        this.filters.type = '1';
                        break;
                    default:
                        this.filters.type = '0';
                }
                resolve();
            });
        },
        setFilter(val) {
            this.filters.year = val.year
            this.filters.quarter = val.quarter
            this.page = 1
            this.rankingData = []
            this.getListRanking()
            this.getMyRank()
        },
        setTab(val) {
            this.filters.type = val
            this.page = 1
            this.rankingData = []
            this.getListRanking()
        },
        getCurrentQuarter() {
            const month = Number(moment().format('M'));
            const year = Number(moment().format('YYYY'));
            const currentQuarter = Math.ceil(month / 3)
            if (currentQuarter === 1) {
                this.filters.quarter = 4
                this.filters.year = year - 1
            } else {
                this.filters.quarter = currentQuarter - 1
                this.filters.year = year
            }
        },
        async getMyRank() {
            this.myRank = null
            const payload = {
                year: this.filters.year,
                quarter: this.filters.quarter,
            }
            await this.$store.dispatch(GET_MY_RANKING, payload).then(res => {
                if (!res.error && res.data) {
                    this.myRank = new RankingModel(res.data, res.data?.rank - 1, this.filters.quarter)
                }
            }).catch(e => {
                console.log(e)
            })
        }
    }
}
</script>
<style scoped>
.ranking {
    background: linear-gradient(to top, #503694 0%, #503694 20%, #AFA4F7 100%) no-repeat fixed;
    background-size: cover;
    color: white;
    padding: 10px 100px;
    border: none !important;
    border-top-left-radius: 250px !important;
}
@media screen and (max-width: 1024px){
    .ranking {
        padding-top: 40px;
        padding-left: 40px;
        padding-right: 40px;
    }
}

@media screen and (max-width: 767px){
    .ranking {
        border-top-left-radius: 0 !important;
        padding: 10px;
    }
}
</style>
